import React from "react";
import "../../styles/PrimaryButton.css";

export const PrimaryButton = ({ label, onClick, style }) => {
  return (
    <button
      className="sheen-button"
      onClick={onClick}
      style={{
        backgroundColor: "#107988",
        boxShadow: "0px 4px 12px 0px #00000026",
        ...style,
      }}
    >
      {label}
    </button>
  );
};